(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/objects/localstorage-handler.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/objects/localstorage-handler.js'); 
svs = svs || {};
svs.tipset = svs.tipset || {};
svs.tipset.objects = svs.tipset.objects || {};

function isRowQueryValid(rowAmount) {
  if (!svs.utils.url.queryString.row) {
    return false;
  }

  var row = svs.utils.url.queryString.row;
  var marks = row.split(',');

  if (marks.length !== rowAmount) {
    return false;
  }

  for (var i = 0; i < marks.length; ++i) {
    if (marks[i].match(/[^1Xx2]+/)) {
      return false;
    }
  }

  return true;
}

svs.tipset.objects.LocalstorageHandler = Marionette.Object.extend({
  log: new svs.core.log.Logger('svs.objects.LocalstorageHandler'),

  getDataFromLocalStorage: function(options) {
    var drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn'),
      id = svs.tipset.models.gameDefinitions.getAPIName(
        svs.tipset.collections.draws.getCurrentDraw().get('productId')
      ),
      self = this;

    this.isSingleRow = this.getIsSingleRow();
    this.isReduceMode = this.getIsReduceMode();

    this.dataFromLocalStorage = svs.components.Storage.browser.get(
      'Wager',
      'svs.' + id + '_' + drawUrlAddOn
    );
    if (this.dataFromLocalStorage) {
      self.log.debug('Wager from localstorage ' + this.dataFromLocalStorage);
    } else {
      self.log.debug('No wager in localstorage');
    }

    var productId = svs.utils.products.resolveProductId(
        svs.tipset.models.gameDefinitions.get('productName')
      ),
      getProductRows = function(productId) {
        switch (productId) {
          case svs.utils.products.productIds.T8STRYK:
          case svs.utils.products.productIds.T8:
          case svs.utils.products.productIds.T8EXTRA:
          case svs.utils.products.productIds.POWERPLAY:
            return 8;
          default:
            return 13;
        }
      };

    if (isRowQueryValid(getProductRows(productId))) {
      var row = svs.utils.url.queryString.row.split(',').map(function(mark) {
        if (mark.length === 0) {
          return '0';
        }
        return mark.replace('x', 'X');
      });

      var weights = [];
      row.forEach(function(mark) {
        if (mark.length === 0) {
          weights.push([0, 0, 0]);
        } else if (mark.length === 1) {
          weights.push([mark.includes('1') ? 100 : 0, mark.includes('X') ? 100 : 0, mark.includes('2') ? 100 : 0]);
        } else if (mark.length === 2) {
          weights.push([mark.includes('1') ? 50 : 0, mark.includes('X') ? 50 : 0, mark.includes('2') ? 50 : 0]);
        } else {
          weights.push([mark.includes('1') ? 33 : 0, mark.includes('X') ? 33 : 0, mark.includes('2') ? 33 : 0]);
        }

      });

      if (!this.dataFromLocalStorage) {
        this.dataFromLocalStorage = {};
      }
      this.dataFromLocalStorage.baseRow = row;
      this.dataFromLocalStorage.boardData = row;
      this.dataFromLocalStorage.numWeeks = 1;
      this.dataFromLocalStorage.weights = weights;

      if (this.dataFromLocalStorage.system) {
        delete this.dataFromLocalStorage.system;
      }

      if (this.dataFromLocalStorage.sportkryssBet) {
        delete this.dataFromLocalStorage.sportkryssBet;
      }

      if (this.dataFromLocalStorage.uRowData) {
        this.dataFromLocalStorage.uRowData = this.dataFromLocalStorage.uRowData.map(
          function() {
            return 0;
          }
        );
      }

      svs.utils.paramHandler.remove({ key: 'row' });

      this.isSingleRow = false;
      this.isReduceMode = false;

      if(svs.tipset.models.play && svs.tipset.models.play.get('isSingleRow') !== this.isSingleRow) {
        svs.tipset.models.play.setIsSingleRow(this.isSingleRow);
      }
      if(svs.tipset.models.play && svs.tipset.models.play.get('isReduceMode') !== this.isReduceMode) {
        svs.tipset.models.play.setIsSingleRow(this.isReduceMode);
      }
      this.saveSingleModeToLocalStorage();
      this.saveReduceModeToLocalStorage();
    }

    if (this.dataFromLocalStorage && svs.tipset.models.reduceFreeContainer) {
      svs.tipset.models.reduceFreeContainer.set(
        'rows',
        this.dataFromLocalStorage.freeReduceRowAmount || 0,
        { silent: true }
      );
      svs.tipset.models.reduceFreeContainer.trigger('updateRows');
    }

    if (options && options.callback) {
      options.callback();
    } else {
      svs.tipset.models.play.setDataFromLocalStorage();
    }
  },

  saveDataToLocalStorage: function() {
    var expires = new Date(
        svs.tipset.collections.draws.getCurrentDraw().get('regCloseTime')
      ),
      drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn'),
      id = svs.tipset.models.gameDefinitions.getAPIName(
        svs.tipset.collections.draws.getCurrentDraw().get('productId')
      ),
      hasSystem =
        svs.tipset.models.systems &&
        svs.tipset.models.systems.getCurrentSystem(),
      system = hasSystem
        ? svs.tipset.models.systems.getCurrentSystem()
        : undefined,
      systemObj = system
        ? { type: system.type, systemNum: system.systemNum }
        : undefined,
      dataToBeSaved = {
        id: id,
        sportkryssBet:
          svs.tipset.models.sportkryss &&
            svs.tipset.models.sportkryss.get('sportkryssBet')
            ? svs.tipset.models.sportkryss.get('sportkryssBet')
            : undefined,
        sportkryssIsValid: svs.tipset.models.sportkryss
          ? svs.tipset.models.sportkryss.get('isValid')
          : undefined,
        system: systemObj,
        quickPick: 0,
        useBoardRow: '',
        boardData: this.getBoardData(),
        uRowData:
          svs.tipset.collections.matchlist &&
            svs.tipset.collections.matchlist.isAnySet() &&
            svs.tipset.collections.matchlist.getURowData()
            ? svs.tipset.collections.matchlist.getURowData()
            : undefined,
        numWeeks: svs.tipset.models.weekPicker
          ? svs.tipset.models.weekPicker.getNumberOfWeeks()
          : 1,
        betAmount:
          svs.tipset.models.betslipExpanded &&
            svs.tipset.models.betslipExpanded.get('amount')
            ? svs.tipset.models.betslipExpanded.get('amount')
            : undefined,
        baseRow: this.getBaseRow(),
        weights: this.getWeights(),
        freeReduceRowAmount: svs.tipset.models.reduceFreeContainer.get('rows')
      };

    svs.components.Storage.browser.set(
      'Wager',
      'svs.' + id + '_' + drawUrlAddOn,
      dataToBeSaved,
      expires,
      function(err) {
        if (err != undefined) {
          this.log.debug('Could not save BoardData: ' + JSON.stringify(err));
        }
      }
    );
  },

  getBaseRow: function() {
    var baseRow;

    if (svs.tipset.models.play.get('isSingleRow')) {
      baseRow =
        svs.tipset.collections.boardCollections &&
          svs.tipset.collections.boardCollections.getBaseRow()
          ? svs.tipset.collections.boardCollections.getBaseRow()
          : undefined;
    } else {
      baseRow =
        svs.tipset.collections.matchlist &&
          svs.tipset.collections.matchlist.getBaseRow()
          ? svs.tipset.utils.convertBoardToItsData(
            svs.tipset.collections.matchlist.getBaseRow()
          )
          : undefined;
    }

    return baseRow;
  },
  getBoardData: function() {
    var boards, boardData;

    if (
      svs.tipset.models.play.get('isSingleRow') &&
      svs.tipset.collections.boardCollections &&
      svs.tipset.collections.boardCollections.isAnySet() &&
      svs.tipset.collections.boardCollections.getActiveBoards()
    ) {
      boardData = [];
      boards = svs.tipset.collections.boardCollections.models;

      _.each(boards, function(board) {
        boardData.push(
          svs.tipset.utils.convertBoardToItsData(board.get('boardData'))
        );
      });
    } else {
      if (
        svs.tipset.collections.matchlist &&
        svs.tipset.collections.matchlist.isAnySet() &&
        svs.tipset.collections.matchlist.getBoardData()
      ) {
        boards = svs.tipset.collections.matchlist.getBoardData();
        boardData = svs.tipset.utils.convertBoardToItsData(boards);
      }
    }

    return boardData;
  },

  getWeights: function() {
    if (svs.tipset.models.play.get('isSingleRow')) {
      return undefined;
    }
    return svs.tipset.collections.matchlist.getWeights();
  },

  clearLocalStorage: function(options) {
    var drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn'),
      id = svs.tipset.models.gameDefinitions.getAPIName(
        svs.tipset.collections.draws.getCurrentDraw().get('productId')
      ),
      next = options && options.next ? options.next : undefined,
      callback = options && options.callback ? options.callback : undefined;
    this.dataFromLocalStorage = undefined;

    svs.components.Storage.browser.remove(
      'Wager',
      'svs.' + id + '_' + drawUrlAddOn,
      function() {
        if (next) {
          next({ callback: callback });
        } else {
          if (callback) {
            callback();
          }
        }
      }
    );
  },

  saveTipsInfo: function() {
    var tipsInfo = Object.assign({}, svs.tipset.models.statistics.getStatistics());
    delete tipsInfo.gameAnalyzes;

    svs.components.Storage.browser.set(
      'Statistics',
      'svs.' + svs.tipset.models.gameDefinitions.get('htmlClass'),
      tipsInfo,
      svs.components.Storage.constants.EXPIRES_1YEAR,
      function(err) {
        if (err != undefined) {
          this.log.debug('Could not save statistics: ' + JSON.stringify(err));
        }
      }
    );
  },

  saveSingleModeToLocalStorage: function() {
    var id = svs.tipset.models.gameDefinitions.get('htmlClass'),
      isSingleRow =
        svs.tipset.models.play && svs.tipset.models.play.get('isSingleRow')
          ? svs.tipset.models.play.get('isSingleRow')
          : false,
      drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn');

    svs.components.Storage.browser.set(
      'singleRowMode',
      'svs.' + id + '_' + drawUrlAddOn,
      isSingleRow,
      svs.components.Storage.constants.EXPIRES_1YEAR,
      function(err) {
        if (err != undefined) {
          this.log.debug('Could not save statistics: ' + JSON.stringify(err));
        }
      }
    );
  },

  saveReduceModeToLocalStorage: function() {
    var id = svs.tipset.models.gameDefinitions.get('htmlClass'),
      isReduceMode =
        svs.tipset.models.play && svs.tipset.models.play.get('isReduceMode')
          ? svs.tipset.models.play.get('isReduceMode')
          : false,
      drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn');

    svs.components.Storage.browser.set(
      'reduceMode',
      'svs.' + id + '_' + drawUrlAddOn,
      isReduceMode,
      svs.components.Storage.constants.EXPIRES_1WEEK,
      function(err) {
        if (err != undefined) {
          this.log.debug('Could not save statistics: ' + JSON.stringify(err));
        }
      }
    );
  },

  saveTransferWager: function() {
    var expires = new Date(
        svs.tipset.collections.draws.getCurrentDraw().get('regCloseTime')
      ),
      drawUrlAddOn = svs.tipset.models.transferWager.get('drawNumber'),
      id = svs.tipset.models.transferWager.get('id'),
      dataToBeSaved = svs.tipset.models.transferWager.attributes;

    svs.components.Storage.browser.set(
      'Wager',
      'svs.' + id + '_' + drawUrlAddOn,
      dataToBeSaved,
      expires,
      function(err) {
        if (err != undefined) {
          this.log.debug('Could not save BoardData: ' + JSON.stringify(err));
        } else {
          svs.tipset.models.transferWager.transferGame();
        }
      }
    );
  },

  getProlongWagerFromLocalStorage: function() {
    var self = this;
    this.dataFromLocalStorage = svs.components.Storage.browser.get(
      'ProlongWager',
      'svs.tipsen'
    );
    if (this.dataFromLocalStorage) {
      self.log.debug('Wager from localstorage ' + this.dataFromLocalStorage);
    } else {
      self.log.debug('No wager in localstorage');
    }
    svs.tipset.models.play.setDataFromLocalStorage();
  },

  clearLocalStorageFromStartPage: function(callback) {
    this.clearLocalStorage({
      next: this.clearSingleRowInLocalStorage,
      callback: callback
    });
    this.dataFromLocalStorage = undefined;
  },

  clearSingleRowInLocalStorage: function(options) {
    var callback = options && options.callback ? options.callback : undefined,
      id = svs.tipset.models.gameDefinitions.get('htmlClass'),
      drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn');

    svs.components.Storage.browser.remove(
      'singleRowMode',
      'svs.' + id + '_' + drawUrlAddOn,
      function() {
        if (callback) {
          callback();
        }
      }
    );
  },

  getIsSingleRow: function() {
    var isSingleRow = false,
      drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn');
    isSingleRow = svs.components.Storage.browser.get(
      'singleRowMode',
      'svs.' +
      svs.tipset.models.gameDefinitions.get('htmlClass') +
      '_' +
      drawUrlAddOn
    );

    if (isSingleRow) {
      this.log.debug('SingleRow from localstorage ' + isSingleRow);
    } else {
      this.log.debug('No SingleRow in localstorage');
    }

    return isSingleRow;
  },

  getIsReduceMode: function() {
    var isReduceMode = false,
      drawUrlAddOn = svs.tipset.collections.draws
        .getCurrentDraw()
        .get('urlAddOn');
    isReduceMode = svs.components.Storage.browser.get(
      'reduceMode',
      'svs.' +
      svs.tipset.models.gameDefinitions.get('htmlClass') +
      '_' +
      drawUrlAddOn

    );

    if (isReduceMode) {
      this.log.debug('ReduceMode from localstorage ' + isReduceMode);
    } else {
      this.log.debug('No ReduceMode in localstorage');
    }

    return isReduceMode || false;
  },

  getTipsInfo: function() {
    var tipsInfoFromLocalStorage = svs.components.Storage.browser.get(
      'Statistics',
      'svs.' + svs.tipset.models.gameDefinitions.get('htmlClass')
    );
    if (tipsInfoFromLocalStorage) {
      this.log.debug('Tipsinfo from localstorage ' + tipsInfoFromLocalStorage);
    } else {
      this.log.debug('No Tipsinfo in localstorage');
    }

    return tipsInfoFromLocalStorage;
  }
});

 })(window);